"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _LazyValueStore = require("../store/LazyValueStore");

var _OwnersActions = require("./OwnersActions");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  namespace: _ActionNamespaces.CURRENT_OWNER_ID,
  fetch: _OwnersActions.fetchCurrentOwnerIdFromCache
}).defineName('CurrentOwnerIdStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;